import instances from 'config/constants/instances';

/**
 * Gates silent 404/501 → mock fixtures for ROPA/APA/DPIA/LIA API modules
 * and matching page-level error→fixture fallbacks.
 *
 * Disabled in production. In non-production, opt in with
 * REACT_APP_ALLOW_ROPA_API_MOCKS=true (keep off when wiring against real BE).
 */
const areRopaApiMocksEnabled = (): boolean => {
  if (process.env.REACT_APP_INSTANCE === instances.PRODUCTION || process.env.NODE_ENV === 'production') {
    return false;
  }

  return process.env.REACT_APP_ALLOW_ROPA_API_MOCKS === 'true';
};

export default areRopaApiMocksEnabled;
